{
  "name": "preludd-backoffice-frontend",
  "version": "2.6.0-beta",
  "versionCustomPay": "2.6.0-beta",
  "description": "Frontend for the Preludd backoffice",
  "source": "src/index.html",
  "author": "tfumey",
  "license": "MIT",
  "scripts": {
    "clean": "rimraf dist && rimraf .parcel-cache && mkdir dist",
    "fixlint": "eslint index.js src/ --fix",
    "lint": "eslint index.js src/",
    "test": "echo \"Error: no test specified\" && exit 1",
    "start": "npm run clean && npm run build-css && parcel index.html --open --no-hmr",
    "build": "npm run clean && parcel build ./index.html",
    "build-test": "npm run build-clean && npm run clean-output && npm run clean-html",
    "build-parcel": "npm run clean && parcel build ./index.html --no-optimize --no-scope-hoist --no-content-hash",
    "build-clean": "npm run build-parcel && esbuild dist/static/frontend-updated.*.js --bundle --loader:.png=dataurl --target=es2016 --outdir=dist/cleaned/static",
    "clean-output": "(cat dist/static/frontend-updated.*.css && cat dist/static/frontend-updated.*.css) | sed '/\\/\\*# sourceMappingURL=/d' > dist/cleaned/static/main.css && mv -f dist/cleaned/static/frontend-updated.*.js dist/cleaned/static/app.js",
    "clean-html": "awk '{gsub(/frontend-updated\\.[a-f0-9]+\\.css/, \"main.css\"); gsub(/frontend-updated\\.[a-f0-9]+\\.js/, \"app.js\"); gsub(/<script[^>]*src=\\\"[^\\\"]*app.js\\\"/, \"<script src=\\\"/static/app.js\\\" type=\\\"text/javascript\\\"\"); sub(/<link rel=\\\"stylesheet\\\" href=\\\"\\/static\\/main.css\\\">/, \"\"); print }' dist/index.html > dist/cleaned/index.html",
    "build-css": "npx tailwindcss -i ./src/globals.css -o ./src/index.css",
    "cy:open": "cypress open --project test",
    "cy:open-dev": "cypress open --project test --config baseUrl=http://localhost:1234/",
    "cy:run": "cypress run --project test",
    "cy:run-dev": "cypress run --project test --config baseUrl=http://localhost:1234/"
  },
  "engines": {
    "node": ">= 22"
  },
  "devDependencies": {
    "@babel/core": "^7.26.0",
    "@eslint/js": "^9.11.1",
    "@parcel/namer-default": "^2.12.0",
    "@parcel/transformer-sass": "^2.12.0",
    "babel-plugin-module-resolver": "^5.0.2",
    "buffer": "^6.0.3",
    "cypress": "^15.14.1",
    "esbuild": "0.25.5",
    "eslint": "^9.11.1",
    "eslint-plugin-react": "^7.37.2",
    "eslint-plugin-tailwindcss": "^3.17.4",
    "globals": "^15.10.0",
    "http-proxy-middleware": "^3.0.3",
    "os-browserify": "^0.3.0",
    "parcel": "^2.12.0",
    "parcel-namer-rewrite": "^2.10.3-rc.2",
    "parcel-reporter-multiple-static-file-copier": "^1.0.5",
    "path-browserify": "^1.0.1",
    "posthtml-expressions": "^1.11.4",
    "process": "^0.11.10",
    "rimraf": "^6.0.1",
    "tailwindcss": "^3.4.13"
  },
  "dependencies": {
    "@ctrl/tinycolor": "^4.1.0",
    "@hookform/resolvers": "^3.9.0",
    "@radix-ui/react-accordion": "^1.2.1",
    "@radix-ui/react-checkbox": "^1.1.2",
    "@radix-ui/react-collapsible": "^1.1.2",
    "@radix-ui/react-dialog": "^1.1.5",
    "@radix-ui/react-dropdown-menu": "^2.1.2",
    "@radix-ui/react-hover-card": "^1.1.4",
    "@radix-ui/react-label": "^2.1.0",
    "@radix-ui/react-menubar": "^1.1.4",
    "@radix-ui/react-popover": "^1.1.4",
    "@radix-ui/react-radio-group": "^1.3.8",
    "@radix-ui/react-scroll-area": "^1.2.1",
    "@radix-ui/react-select": "^2.1.2",
    "@radix-ui/react-separator": "^1.1.0",
    "@radix-ui/react-slot": "^1.1.1",
    "@radix-ui/react-switch": "^1.1.1",
    "@radix-ui/react-tabs": "^1.1.1",
    "@radix-ui/react-toast": "^1.2.2",
    "@radix-ui/react-tooltip": "^1.1.8",
    "@tanstack/react-table": "^8.20.5",
    "axios": "^1.7.7",
    "class-variance-authority": "^0.7.0",
    "clsx": "^2.1.1",
    "config": "^3.3.12",
    "eslint-plugin-jsdoc": "^50.4.3",
    "i18next": "^23.16.2",
    "i18next-browser-languagedetector": "^8.0.0",
    "input-otp": "^1.4.2",
    "jspdf": "^3.0.1",
    "leaflet": "^1.9.4",
    "lucide-react": "^0.563.0",
    "luxon": "^3.5.0",
    "material-color-hash": "^0.1.6",
    "prop-types": "^15.8.1",
    "qrcode.react": "^4.2.0",
    "react": "^18.3.1",
    "react-day-picker": "^9.7.0",
    "react-dom": "^18.3.1",
    "react-helmet-async": "^2.0.5",
    "react-hook-form": "^7.53.0",
    "react-i18next": "^15.1.0",
    "react-leaflet": "^4.2.1",
    "react-query": "^3.39.3",
    "react-router-dom": "^6.26.2",
    "react-select": "^5.10.2",
    "recharts": "^3.2.1",
    "tailwind-merge": "^2.5.2",
    "tailwindcss-animate": "^1.0.7",
    "use-event-bus-hook": "^0.0.3",
    "zod": "3.23.8",
    "zod-i18n-map": "^2.27.0",
    "zustand": "^5.0.0-rc.2"
  },
  "@parcel/runtime-js": {
    "splitManifestThreshold": 1000000
  },
  "@parcel/resolver-default": {
    "packageExports": true
  },
  "multipleStaticFileCopier": [
    {
      "origin": "resource",
      "destination": "dist/static/resource/"
    }
  ],
  "parcel-namer-rewrite": {
    "chain": "@parcel/namer-default",
    "hashing": "always",
    "disable": false,
    "rules": {
      "(.*)\\.(svg|png|gif|jpg)": "static/resource/images/$1.{hash.}$2",
      "(.*)\\.(csv)": "static/resource/files/$1.{hash.}$2",
      "(.*)\\.(i18n)": "static/resource/locales/$1.{hash.}$2",
      "(.*)\\.(js|css|scss)": "static/$1.{hash.}$2"
    }
  },
  "browserslist": "since 2015"
}